import React from 'react';

const MobileDebugInfo = ({ nfcTagId, currentPlayer, showSuccess, showError, showInfo }) => {
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    return (
        <div className="mobile-debug" style={{
            position: 'fixed',
            top: '10px',
            right: '10px',
            background: 'rgba(0,0,0,0.8)',
            color: 'white',
            padding: '8px',
            borderRadius: '5px',
            fontSize: '11px',
            zIndex: 9998
        }}>
            <div>📱 Mobile Mode</div>
            <div>NFC: {nfcTagId || 'BRAK'}</div>
            <div>Player: {currentPlayer?.avatar?.name || 'BRAK'}</div>
            <div style={{ marginTop: '5px', display: 'flex', gap: '3px' }}>
                <button onClick={() => showSuccess('Test mobile!')} style={{ fontSize: '9px', padding: '2px' }}>✅</button>
                <button onClick={() => showError('Test mobile!')} style={{ fontSize: '9px', padding: '2px' }}>❌</button>
                <button onClick={() => showInfo('Test mobile!')} style={{ fontSize: '9px', padding: '2px' }}>ℹ️</button>
            </div>
        </div>
    );
};

export default MobileDebugInfo;